import {Component, OnInit, inject} from '@angular/core';
import {EventsManager} from '../../events/events.manager';
import {ActivatedRoute, Router} from '@angular/router';
import {BenefitPlanTemplateModel} from '../../models/plans.model';
import {GroupCodeUtility} from '../../utils/group-code.utility';
import {hydratePlanSelectionFromUrlIfPresent} from '../../utils/plan-selection.util';

@Component({
  selector: 'app-ancillary-benefits-detail',
  templateUrl: './ancillary-benefits-detail.component.html',
  styleUrls: ['./ancillary-benefits-detail.component.scss'],
  standalone: false
})

export class AncillaryBenefitsDetailComponent implements OnInit {
  private _eventsManager: EventsManager = inject(EventsManager);
  private _router: Router = inject(Router);
  private _route: ActivatedRoute = inject(ActivatedRoute);

  private _template: BenefitPlanTemplateModel | undefined;
  public ancillaryCodes: string = '';

  public ngOnInit(): void {
    window.scrollTo(0, 0);
    hydratePlanSelectionFromUrlIfPresent(this._route.snapshot.queryParamMap, this._eventsManager);

    if (this._eventsManager?.planDetailInfo?.templateId) {
      this._template = this._eventsManager.getOfficeInfo()?.benefitPlanTemplates?.find((template: BenefitPlanTemplateModel): boolean => template.benefitPlanTemplateId == this._eventsManager.planDetailInfo.templateId);
      this.ancillaryCodes = this._template?.ancillaryBenefits || '';
    }
  }

  public goBack(): void {
    this._router.navigate(['/plan'], {queryParams: {
      practiceId: this._eventsManager.planDetailInfo?.practiceId,
      templateId: this._eventsManager.planDetailInfo?.templateId,
      coverageLevelName: this._route.snapshot.queryParamMap.get('coverageLevelName') || this._eventsManager.selectedLevel?.caption,
      pageName: this._eventsManager.planDetailInfo?.pageName ?? 'PlanDetails'
    }});
  }

  public navigateToSearch(): void {
    const groupCode: string = GroupCodeUtility.determineGroupCode(this.ancillaryCodes);
    const baseUrl = window.location.origin;
    const searchUrl = `${baseUrl}/ancillary-search?groupCode=${encodeURIComponent(groupCode)}`;
    window.open(searchUrl, '_blank');
  }
}
